import API_ENDPOINT from '../global/api-endpoint';

class AppSource {
  static async _get(endpoint) {
    try {
      const response = await fetch(endpoint);
      const responseJson = await response.json();
      const data = {
        error: false,
        data: responseJson,
      };
      return data;
    } catch (error) {
      const data = {
        error: true,
        data: error,
      };
      return data;
    }
  }

  static getSurahs() {
    return this._get(API_ENDPOINT.GET_SURAHS);
  }

  static getSurah(numberSurah) {
    return this._get(API_ENDPOINT.GET_SURAH(numberSurah));
  }

  static getAyahs(numberSurah) {
    return this._get(API_ENDPOINT.GET_AYAHS(numberSurah));
  }

  static getAyah(numberSurah, numberAyah) {
    return this._get(API_ENDPOINT.GET_AYAH(numberSurah, numberAyah));
  }

  static getRandomAyah() {
    return this._get(API_ENDPOINT.GET_RANDOM_AYAH);
  }
}

export default AppSource;
